<template>
  <div
    class="voice-room-main"
    :style="{ 'background-image': `url(${roomInfo.backImgUrl})` }"
  >
    <room-info class="room-info"></room-info>
    <div class="main">
      <seat-page @click-seat="openUserInfoDialog"></seat-page>
      <action-page ref="actionPage" class="action-page"></action-page>
      <p class="desc">公告： {{ roomInfo.desc }}</p>
      <video-player class="im-video"></video-player>
      <user-info-dialog
        ref="userInfoDialog"
        @sendGift="sendGift"
      ></user-info-dialog>
    </div>
  </div>
</template>
<script>
import ActionPage from './action-page.vue';
import SeatPage from './seat-page.vue';
import VideoPlayer from './video.vue';
import UserInfoDialog from './user-info-dialog.vue';
import VoiceRoomProvider from '@/components/VoiceRoom/voiceRoomProvider';
import RoomInfo from '@/components/VoiceRoom/component/room-info.vue';

export default {
  components: {
    SeatPage,
    ActionPage,
    VideoPlayer,
    UserInfoDialog,
    RoomInfo
  },
  name: 'VoiceRoomMain',
  props: {},
  data() {
    return {};
  },
  watch: {},
  computed: {
    roomInfo() {
      return VoiceRoomProvider.roomInfo;
    }
  },
  methods: {
    openUserInfoDialog(userId) {
      this.$refs.userInfoDialog.show(userId);
    },
    sendGift(userInfo) {
      console.log(userInfo);
      this.$refs.actionPage.sendGift(
        [
          {
            isSelect: true,
            user: {
              avatarURL: userInfo.avatarUrl,
              userUuid: userInfo.uuid
            }
          }
        ],
        true
      );
    }
  }
};
</script>
<style lang="scss" scoped>
.voice-room-main {
  width: 520px;
  background-size: cover;
  border-radius: 20px;
  border-radius: 20px;
  overflow: hidden;
  position: relative;
}
.room-info {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 2;
}
.desc {
  position: absolute;
  // bottom: 152px;
  top: 567px;
  left: 48px;
  width: 240px;
  padding: 10px;
  border-radius: 4px;
  background: rgba(255, 255, 255, 0.1);
  color: rgba(255, 255, 255, 0.33);
  font-size: 14px;
  height: 125px;
  overflow: scroll;
  @include hideScrollBar(0, 0);
  word-break: break-word;
}
.main {
  width: 100%;
  height: 100%;
  background-color: rgba(21, 32, 44, 0.4);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: relative;
  background-size: cover;
}
.im-video {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: -1;
}
.action-page {
  margin-bottom: 37px;
  z-index: 2;
}
</style>
<style lang="scss">
.im-video {
  canvas: {
    pointer-events: none;
  }
}
</style>
